import { __extends, __assign } from 'tslib';
import * as React from 'react';
import TooltipWrapper from './TooltipWrapper.js';

var TooltipProvider = (function (_super) {
    __extends(TooltipProvider, _super);
    function TooltipProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prevContent = null;
        _this.isVisible = function () {
            if (_this.TooltipWrapper) {
                return _this.TooltipWrapper.state.isTooltipVisible;
            }
            else {
                return false;
            }
        };
        _this.setBodyContentIfNeeded = function (content) {
            if (!_this.TooltipWrapper.state.body) {
                _this.TooltipWrapper.setState({ body: content });
            }
        };
        _this.show = function (content, delay, usePrev) {
            if (_this.TooltipWrapper) {
                if (usePrev && _this.prevContent) {
                    _this.TooltipWrapper.setState({ isTooltipVisible: true, body: _this.prevContent });
                }
                else {
                    _this.prevContent = content;
                    _this.TooltipWrapper.setState({ isTooltipVisible: true, body: content });
                }
            }
        };
        _this.hide = function (removeContent) {
            if (_this.TooltipWrapper) {
                if (removeContent) {
                    _this.prevContent = null;
                }
                _this.TooltipWrapper.setState({ isTooltipVisible: false, body: null });
            }
        };
        _this.update = function (position) {
            if (_this.TooltipWrapper) {
                _this.TooltipWrapper.setState({ position: position, isTooltipVisible: true });
            }
        };
        return _this;
    }
    TooltipProvider.prototype.componentDidMount = function () {
        if (typeof window !== undefined && !window.tooltipProvider) {
            window.tooltipProvider = this;
        }
        document === null || document === void 0 ? void 0 : document.addEventListener('mousewheel', this.onmousewheel);
    };
    TooltipProvider.prototype.componentWillUnmount = function () {
        if (typeof window !== undefined && window.tooltipProvider) {
            delete window.tooltipProvider;
        }
        document === null || document === void 0 ? void 0 : document.removeEventListener('mousewheel', this.onmousewheel);
    };
    TooltipProvider.prototype.onmousewheel = function () {
        if (window === null || window === void 0 ? void 0 : window.tooltipProvider) {
            window.tooltipProvider.hide();
        }
    };
    TooltipProvider.prototype.render = function () {
        var _this = this;
        var _a;
        var keyChildren = __assign(__assign({}, this.props.children), { key: 'TooltipProviderChildren' });
        return [
            keyChildren,
            React.createElement(TooltipWrapper, { className: ((_a = this.props) === null || _a === void 0 ? void 0 : _a.className) || '', ref: function (r) {
                    _this.TooltipWrapper = r;
                }, key: 'TooltipWrapper' }),
        ];
    };
    return TooltipProvider;
}(React.PureComponent));

export { TooltipProvider as default };
//# sourceMappingURL=TooltipProvider.js.map
